import {Injectable} from '@angular/core';
import {CartInterface} from '../cart/cart.interface';
import {Cart, CartTotal, Scrap, TicketIds, CartService as Api, LegacyTicket, CartEvent} from '../../generated/sales-terminal-client';
import {Observable, tap} from 'rxjs';
import {AuthService} from '../auth/auth.service';
import {LanguageService} from '../language/language.service';
import {SnackService} from '../snack/snack.service';
import {StorageService} from '../storage/storage.service';
import {PriceInCentsPipe} from '../../pipes/priceInCents/priceInCents.pipe';
import {TicketPricePipe} from '../../pipes/ticketPrice/ticketPrice.pipe';
import {PricePipe} from '../../pipes/price/price.pipe';
import {cloneDeep} from 'lodash-es';
import {CartService} from '../cart/cart.service';
import {CartBaseService} from '../cart/cart-base.service';
import {EventService} from '../event/event.service';
import {RouteService} from '../route/route.service';
import {SelfServiceEventService} from '../self-service/event/self-service-event.service';
import {CentrePropertyService} from "../centre-property/centre-property.service";

export interface ScrapTicket extends LegacyTicket {
  blankNumber?: string;
}
export interface CartScrapEvent extends CartEvent {
  legacyTickets: ScrapTicket[];
}

@Injectable()
export class ScrapService extends CartBaseService implements CartInterface<Cart> {
  public static STORAGE_CART_SCRAP = 'cart.scrap';

  constructor(private _api: Api,
              private cartService: CartService,
              protected authService: AuthService,
              protected centrePropertyService: CentrePropertyService,
              protected languageService: LanguageService,
              protected snackService: SnackService,
              protected storageService: StorageService,
              protected eventService: EventService,
              protected selfServiceEventService: SelfServiceEventService,
              protected routeService: RouteService,
              protected priceInCentsPipe: PriceInCentsPipe,
              protected ticketPricePipe: TicketPricePipe,
              protected pricePipe: PricePipe) {
    super(authService, centrePropertyService, languageService, snackService, storageService, eventService, selfServiceEventService, routeService, priceInCentsPipe, ticketPricePipe, pricePipe);
    if (storageService.get(ScrapService.STORAGE_CART_SCRAP)) {
      this._cart = JSON.parse(storageService.get(ScrapService.STORAGE_CART_SCRAP));
    }
  }

  public override get events(): CartScrapEvent[] {
    return super.events as CartScrapEvent[];
  }

  public override get cart(): Cart {
    return this._cart || this._emptyCart;
  }
  public override set cart(newCart: Cart) {
    this._cart = newCart;
    this.cartTotal = newCart.total;
    this.mapTickets(this._cart.events);
    this.updateSelectionMap();
    this.storageService.set(ScrapService.STORAGE_CART_SCRAP, JSON.stringify(newCart));
  }

  public retryCart(): void {
    if (this.storageService.get(ScrapService.STORAGE_CART_SCRAP)) {
      this.cart = JSON.parse(this.storageService.get(ScrapService.STORAGE_CART_SCRAP));
      this.updateTotalScrapSum();
    } else {
      this.clearScrap();
    }
  }

  public subTotals(ticketIds: TicketIds): Observable<CartTotal> {
    return this.cartService.subTotals(ticketIds);
  }
  public updateSubTotals(preserveSelected?: boolean, preserveGifts?: boolean): void {
    this.isLoading = true;
    if (this.hasSelectedTickets) {
      this.retryCart();
      let selectedTicketCount: number = this.getSelectedTicketIds.length;
      this.cart.total.ticketQuantity = selectedTicketCount;
      this.cart.total.total = (this.cart.total.total / (this.ticketCount || 1)) * selectedTicketCount;
      this.cart.total.ticketTotal = (this.cart.total.ticketTotal / (this.ticketCount || 1)) * selectedTicketCount;
      this.cartTotal = this.cart.total;
      this.setSubTotals(this.cartTotal);
      this.isLoading = false;
    } else {
      this.setSubTotals(cloneDeep(this._emptyTotals));
      this.isLoading = false;
    }
  }

  public clearScrap(): void {
    this.cart = cloneDeep(this._emptyCart);
  }

  public processScrap(scrap: Scrap): Observable<TicketIds> {
    return this._api.cartScrapPost(scrap).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }
}
